"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OneGroupingReadOnlySection = exports.MultipleGroupingsSection = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("react-bootstrap/lib");

var _PropTypes = require("../PropTypes.js");

var _lodash = require("lodash");

require("./Components.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var headerName = function headerName(name) {
  return name.replace(/_/g, " ").replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  }) + ": ";
};

var humanize = function humanize(name) {
  return name.replaceAll("_", " ").toLowerCase();
};

var CommonPropTypes = {
  name: _PropTypes.ColumnGroupPropTypes.name,
  availableIds: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  selectedIds: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired
};
var ManyGroupingsPropTypes = Object.assign({}, CommonPropTypes, {
  groupings: _PropTypes.ColumnGroupPropTypes.groupings,
  onNewSelectedIds: _propTypes["default"].func.isRequired
});
var SELECTION = {
  UNSELECTED: "unselected",
  PARTIAL: "partiallySelected",
  SELECTED: "selected"
};
var SELECTION_LIST = [SELECTION.UNSELECTED, SELECTION.PARTIAL, SELECTION.SELECTED];
var GroupingPropTypes = {
  text: _propTypes["default"].string.isRequired,
  selection: _propTypes["default"].oneOf(SELECTION_LIST).isRequired,
  onToggle: _propTypes["default"].func
};

var determineGroupingSelection = function determineGroupingSelection(_ref) {
  var selectedIds = _ref.selectedIds,
      groupingIds = _ref.groupingIds;
  var idsInGroupingAndSelected = (0, _lodash.intersection)(selectedIds, groupingIds);
  var idsInGroupingButNotSelected = (0, _lodash.difference)(groupingIds, idsInGroupingAndSelected);
  var isFullySelected = groupingIds.length > 0 && idsInGroupingButNotSelected.length === 0;
  var isFullyUnselected = idsInGroupingAndSelected.length === 0;
  return isFullyUnselected ? SELECTION.UNSELECTED : isFullySelected ? SELECTION.SELECTED : SELECTION.PARTIAL;
};

var makeGroupingProps = function makeGroupingProps(_ref2, grouping) {
  var selectedIds = _ref2.selectedIds,
      onNewSelectedIds = _ref2.onNewSelectedIds;
  var groupingSelection = determineGroupingSelection({
    selectedIds: selectedIds,
    groupingIds: grouping[1]
  });
  return {
    key: grouping[0],
    text: grouping[0],
    selection: groupingSelection,
    onToggle: groupingSelection === SELECTION.UNSELECTED ? function () {
      onNewSelectedIds((0, _lodash.union)(grouping[1], selectedIds));
    } : function () {
      onNewSelectedIds((0, _lodash.difference)(selectedIds, grouping[1]));
    }
  };
};

var ReadOnlyGrouping = function ReadOnlyGrouping(_ref3) {
  var text = _ref3.text,
      selection = _ref3.selection;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "readOnlyGrouping " + selection
  }, text);
};

ReadOnlyGrouping.propTypes = GroupingPropTypes;

var CheckboxGrouping = function CheckboxGrouping(_ref4) {
  var name = _ref4.name,
      text = _ref4.text,
      selection = _ref4.selection,
      onToggle = _ref4.onToggle;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkboxGrouping " + selection
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    value: text,
    onChange: onToggle,
    checked: [SELECTION.SELECTED, SELECTION.PARTIAL].indexOf(selection) > -1,
    ref: function ref(checkbox) {
      checkbox ? checkbox.indeterminate = selection === SELECTION.PARTIAL : null;
    }
  }), text ? /*#__PURE__*/_react["default"].createElement("span", null, text) : /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      opacity: 0.5,
      fontStyle: "italic"
    }
  }, humanize(name), " not specified"));
};

CheckboxGrouping.propTypes = GroupingPropTypes;

var PlainSectionBody = function PlainSectionBody(_ref5) {
  var name = _ref5.name,
      groupings = _ref5.groupings,
      selectedIds = _ref5.selectedIds,
      onNewSelectedIds = _ref5.onNewSelectedIds;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "sectionBody"
  }, groupings.map(function (e) {
    return e;
  }).sort(function (g1, g2) {
    return g1[0].localeCompare(g2[0]);
  }).map(function (grouping) {
    return /*#__PURE__*/_react["default"].createElement(CheckboxGrouping, _extends({}, makeGroupingProps({
      selectedIds: selectedIds,
      onNewSelectedIds: onNewSelectedIds
    }, grouping), {
      name: name
    }));
  }));
};

PlainSectionBody.propTypes = ManyGroupingsPropTypes;

var filterGroupingsBySelections = function filterGroupingsBySelections(_ref6, selectionsAllowed, groupings) {
  var selectedIds = _ref6.selectedIds;
  return groupings.filter(function (grouping) {
    return selectionsAllowed.indexOf(makeGroupingProps({
      selectedIds: selectedIds
    }, grouping).selection) > -1;
  });
};

var SELECTION_DESCRIPTIONS = {};
SELECTION_DESCRIPTIONS[SELECTION.UNSELECTED] = "currently not selected";
SELECTION_DESCRIPTIONS[SELECTION.PARTIAL] = "partially selected";
SELECTION_DESCRIPTIONS[SELECTION.SELECTED] = "";

var SelectionOption = function SelectionOption(_ref7) {
  var selection = _ref7.selection,
      isCurrentlyShown = _ref7.isCurrentlyShown,
      groupingsForThisSelection = _ref7.groupingsForThisSelection;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "linksForToggleShow"
  }, "".concat(groupingsForThisSelection.length, " options ").concat(SELECTION_DESCRIPTIONS[selection], " - ").concat(isCurrentlyShown ? "hide" : "show", " ..."));
};

SelectionOption.propTypes = {
  selection: _propTypes["default"].oneOf(SELECTION_LIST).isRequired,
  isCurrentlyShown: _propTypes["default"].bool.isRequired,
  groupingsForThisSelection: _PropTypes.ColumnGroupPropTypes.groupings
};

var SectionBodyWithCollapsableLinks = /*#__PURE__*/function (_React$Component) {
  _inherits(SectionBodyWithCollapsableLinks, _React$Component);

  var _super = _createSuper(SectionBodyWithCollapsableLinks);

  function SectionBodyWithCollapsableLinks(props) {
    var _this;

    _classCallCheck(this, SectionBodyWithCollapsableLinks);

    _this = _super.call(this, props);
    _this.state = {
      showUnselected: _this._countUnselected() < 7,
      showPartiallySelected: _this._countPartiallySelected() < 7
    };
    return _this;
  }

  _createClass(SectionBodyWithCollapsableLinks, [{
    key: "_countUnselected",
    value: function _countUnselected() {
      return filterGroupingsBySelections(this.props, [SELECTION.UNSELECTED], this.props.groupings).length;
    }
  }, {
    key: "_countPartiallySelected",
    value: function _countPartiallySelected() {
      return filterGroupingsBySelections(this.props, [SELECTION.PARTIAL], this.props.groupings).length;
    }
  }, {
    key: "_countSelected",
    value: function _countSelected() {
      return filterGroupingsBySelections(this.props, [SELECTION.SELECTED], this.props.groupings).length;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          name = _this$props.name,
          groupings = _this$props.groupings,
          selectedIds = _this$props.selectedIds,
          onNewSelectedIds = _this$props.onNewSelectedIds;
      var _this$state = this.state,
          showUnselected = _this$state.showUnselected,
          showPartiallySelected = _this$state.showPartiallySelected;

      var unselectedGroupingsCount = this._countUnselected();

      var partiallySelectedGroupingsCount = this._countPartiallySelected();

      var selectedGroupingsCount = this._countSelected();

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "sectionBody"
      }, filterGroupingsBySelections({
        selectedIds: selectedIds
      }, [].concat(showUnselected ? [SELECTION.UNSELECTED] : [], showPartiallySelected ? [SELECTION.PARTIAL] : [], [SELECTION.SELECTED]), groupings).sort(function (g1, g2) {
        return g1[0].localeCompare(g2[0]);
      }).map(function (grouping) {
        return /*#__PURE__*/_react["default"].createElement(CheckboxGrouping, _extends({}, makeGroupingProps({
          selectedIds: selectedIds,
          onNewSelectedIds: onNewSelectedIds
        }, grouping), {
          name: name
        }));
      }), !!unselectedGroupingsCount && /*#__PURE__*/_react["default"].createElement("span", {
        className: "linkForToggleShow",
        onClick: function onClick() {
          _this2.setState(function (_ref8) {
            var showUnselected = _ref8.showUnselected;
            return {
              showUnselected: !showUnselected
            };
          });
        }
      }, showUnselected ? "(hide unselected)" : "".concat(selectedGroupingsCount ? "+ " : "").concat(unselectedGroupingsCount, " unselected (show...)")), /*#__PURE__*/_react["default"].createElement("br", null), !!partiallySelectedGroupingsCount && /*#__PURE__*/_react["default"].createElement("span", {
        className: "linkForToggleShow",
        onClick: function onClick() {
          _this2.setState(function (_ref9) {
            var showPartiallySelected = _ref9.showPartiallySelected;
            return {
              showPartiallySelected: !showPartiallySelected
            };
          });
        }
      }, showPartiallySelected ? "(hide partially selected)" : "".concat(selectedGroupingsCount ? "+ " : "").concat(this._countPartiallySelected(), " partially selected (show...)")));
    }
  }]);

  return SectionBodyWithCollapsableLinks;
}(_react["default"].Component);

SectionBodyWithCollapsableLinks.propTypes = ManyGroupingsPropTypes;

var OneGroupingReadOnlySection = function OneGroupingReadOnlySection(_ref10) {
  var name = _ref10.name,
      text = _ref10.text,
      availableIds = _ref10.availableIds,
      selectedIds = _ref10.selectedIds;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-large gxaSection"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "title"
  }, headerName(name)), /*#__PURE__*/_react["default"].createElement(ReadOnlyGrouping, {
    text: text,
    selection: determineGroupingSelection({
      selectedIds: selectedIds,
      groupingIds: availableIds
    })
  }));
};

exports.OneGroupingReadOnlySection = OneGroupingReadOnlySection;
OneGroupingReadOnlySection.propTypes = Object.assign({}, CommonPropTypes, {
  text: _propTypes["default"].string
});

var MultipleGroupingsSection = /*#__PURE__*/function (_React$Component2) {
  _inherits(MultipleGroupingsSection, _React$Component2);

  var _super2 = _createSuper(MultipleGroupingsSection);

  function MultipleGroupingsSection(props) {
    var _this3;

    _classCallCheck(this, MultipleGroupingsSection);

    _this3 = _super2.call(this, props);
    _this3.state = {
      open: _this3.props.primary
    };
    return _this3;
  }

  _createClass(MultipleGroupingsSection, [{
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          name = _this$props2.name,
          groupings = _this$props2.groupings;
      var open = this.state.open;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "margin-top-large gxaSection"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "title openable",
        onClick: function onClick() {
          _this4.setState(function (_ref11) {
            var open = _ref11.open;
            return {
              open: !open
            };
          });
        },
        href: "#"
      }, headerName(name), /*#__PURE__*/_react["default"].createElement(_lib.Glyphicon, {
        style: {
          fontSize: "x-small",
          paddingLeft: "5px"
        },
        glyph: open ? "menu-up" : "menu-down"
      })), open && (groupings.length > 10 ? /*#__PURE__*/_react["default"].createElement(SectionBodyWithCollapsableLinks, this.props) : /*#__PURE__*/_react["default"].createElement(PlainSectionBody, this.props)));
    }
  }]);

  return MultipleGroupingsSection;
}(_react["default"].Component);

exports.MultipleGroupingsSection = MultipleGroupingsSection;
MultipleGroupingsSection.propTypes = ManyGroupingsPropTypes;